// import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from "react";
import "../assets/css/UploadSettings.scss";
import { ReactComponent as DeleteBg } from '../assets/icons/delete-bg-24.svg';
import SelectionPanel from "../panels/SelectionPanel";
import { getFileType, getIconByFileType, getShortName } from "../utils/customUtil";
import ImageComponent from "./ImageComponent";
import CanvasDragAndDrop from "./canvas/CanvasDragAndDrop";

const UploadSettings = ({
                            isMarkToolRelease,
                            docList,
                            addImageOnCanvas,
                            removeDocumentById,
                            setImageList,
                            setDocList,
                            uploadDocument,
                            canvas,
                            activeSelection,
                            activeTool,
                            drawColor,
                            setDrawColor,
                            setZoom,
                            zoom,
                            textConfiguration,
                            setTextConfiguration,
                            pinnedImages,
                            imageList,
                            canvasList,
                            setCanvasList,
                            removeCanvasTemporary,
                            setActiveCanvasId,
                            reArrangeCanvasHandler,
                            onSetActiveTab,
                            tmpTabName
                        }) => {
    const inputFile = useRef(null);
    const dropArea = useRef(null);
    const [activeTab, setActiveTab] = useState("images");

    useEffect(() => {
        if (tmpTabName !== null) {
            setActiveTab(tmpTabName);
        }
    }, [tmpTabName]);

    useEffect(() => {
        if (canvas) {
            canvas?.on("mouse:down", function(options) {
                if (options.target === null && activeTool === "select") {
                    setActiveTab("images");
                } else {
                    setActiveTab("property");
                }
            });
        }
    }, [canvas, activeTool]);

    useEffect(() => {
        if (activeTool !== "select") {
            setActiveTab("property");
        }
    }, [activeTool]);

    useEffect(() => {
        if (activeSelection) {
            setActiveTab("property");
        }
    }, [activeSelection]);

    const processFiles = (e, files) => {
        e.preventDefault();
        dropArea.current.style.backgroundColor = "#fff";
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        const newFiles = [];
        for (const file of files) {
            const d1 = new Date();
            file.uId = d1.getTime() + Math.round(Math.random() * 1000000);
            file.fileType = !allowedTypes.includes(file.type)
                ? "PRODUCT_NOT_IMAGE"
                : "REFERENCE_IMAGE";
            newFiles.push(file);
        }
        if (uploadDocument && newFiles.length > 0) {
            uploadDocument(newFiles);
        }
    };

    const handleDelete = (item) => {
        if (removeDocumentById !== undefined) {
            removeDocumentById(item);
        }
        const tmpImageList = imageList.filter((image) => image.id !== item.id);
        setImageList(tmpImageList);
    };

    const renderImageList = () => {

        return imageList?.map((item, index) => {
            return (
                <React.Fragment key={`single_image_${index}`}>
                    <ImageComponent
                        item={item}
                        addImageOnCanvas={addImageOnCanvas}
                        handleDelete={handleDelete}
                    />
                </React.Fragment>
            );
        });
    };

    const renderPinnedImageList = () => {
        return pinnedImages?.map((item, index) => {
            return (
                <div
                    key={`single_pinned_image_${index}`}
                    className="single-image-preview"
                    draggable={false}
                >
                    <img
                        onClick={() => addImageOnCanvas(item)}
                        src={item.docUrl}
                        alt="img"
                        // crossOrigin="anonymous"
                    />
                    <span className="pinned-image-sign">P</span>
                </div>
            );
        });
    };

    const handleDocOpen = (url) => {
        window.open(url, "_blank");
    };

    const handleDeleteDoc = (item) => {
        if (removeDocumentById !== undefined) {
            removeDocumentById(item);
        }
        const tmpDocList = docList.filter((doc) => doc.id !== item.id);
        setDocList(tmpDocList);
    };
    // console.log('Doc List:', docList)

    const renderDocList = () => {
        return docList.map((item, index) => {
            return (
                <span
                    className="single-doc-view"
                    key={`single_doc_image_${index}`}
                >
                    {/*<Tooltip title={item.name} placement='top' arrow>*/}
                    <p key={`doc_${index}`}>
                            <span className="icons">
                                <span
                                    className="delete-icon"
                                    onClick={() => handleDeleteDoc(item)}
                                >
                                    <DeleteBg />
                                </span>
                                <span
                                    className="file-icon"
                                    onClick={() => handleDocOpen(item.docUrl)}
                                >
                                    {getIconByFileType(
                                        getFileType(item.docUrl)
                                    )}
                                </span>
                            </span>
                            <span
                                className="text"
                                onClick={() => handleDocOpen(item.docUrl)}
                            >
                                {getShortName(item.name, 22)}
                            </span>
                        </p>
                    {/*</Tooltip>*/}
                </span>
            );
        });
    };

    const renderCanvasLists = () => {
        return (
            <CanvasDragAndDrop
                canvasList={canvasList}
                setActiveCanvasId={setActiveCanvasId}
                reArrangeCanvasHandler={reArrangeCanvasHandler}
            />
        );
    };

    const renderImagesOrFiles = () => {
        return (
            <>
                <div className={activeTab === "images" ? "" : "hidden"}>
                    <div className="file-upload">
                        <div
                            className="drop"
                            ref={dropArea}
                            onClick={() => inputFile.current.click()}
                            onDrop={(e) =>
                                processFiles(e, e.dataTransfer.files)
                            }
                            onDragOver={(e) => {
                                e.preventDefault();
                                dropArea.current.style.backgroundColor = "#ddd";
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                dropArea.current.style.backgroundColor = "#fff";
                            }}
                        >
                            <div className="info">Upload image</div>
                        </div>

                        <input
                            type="file"
                            onChange={(e) =>
                                processFiles(e, inputFile.current.files)
                            }
                            onClick={(e) => (e.target.value = null)}
                            multiple
                            ref={inputFile}
                            style={{ display: "none" }}
                        />
                    </div>
                    <div className="file-preview">
                        {renderImageList()}
                        {renderPinnedImageList()}
                    </div>
                    <div className="doc-preview">{renderDocList()}</div>
                </div>
                <div className={activeTab === "property" ? "" : "hidden"}>
                    <SelectionPanel
                        canvas={canvas}
                        activeSelection={activeSelection}
                        activeTool={activeTool}
                        drawColor={drawColor}
                        setDrawColor={setDrawColor}
                        setZoom={setZoom}
                        zoom={zoom}
                        textConfiguration={textConfiguration}
                        setTextConfiguration={setTextConfiguration}
                        isMarkToolRelease={isMarkToolRelease}
                    />
                </div>
                <div className={activeTab === "artboard" ? "" : "hidden"}>
                    {renderCanvasLists()}
                </div>
            </>
        );
    };

    return (
        <>
            <ul className="prodNav">
                <li
                    id="pTab1"
                    className={
                        activeTab === "property" ? "ptItem active" : "ptItem"
                    }
                    onClick={() => setActiveTab("property")}
                >
                    PROPERTY
                </li>
                <li
                    id="pTab2"
                    className={
                        activeTab === "images" ? "ptItem active" : "ptItem"
                    }
                    onClick={() => setActiveTab("images")}
                >
                    IMAGE
                </li>
                <li
                    id="pTab3"
                    className={
                        activeTab === "files" ? "ptItem active" : "ptItem"
                    }
                    onClick={() => {
                        onSetActiveTab("files");
                        setActiveTab("files");
                    }}
                >
                    FILES
                </li>
                <li
                    id="pTab4"
                    className={
                        activeTab === "block" ? "ptItem active" : "ptItem"
                    }
                    onClick={() => {
                        onSetActiveTab("block");
                        setActiveTab("block");
                    }}
                >
                    BLOCK SUGGESTION
                </li>
                <li
                    id="pTab5"
                    className={
                        activeTab === "artboard" ? "ptItem active" : "ptItem"
                    }
                    onClick={() => {
                        setActiveTab("artboard");
                    }}
                >
                    ARRANGE ARTBOARD
                </li>
            </ul>

            <div className="prodBody">{renderImagesOrFiles()}</div>
        </>
    );
};

export default UploadSettings;
